<div class="dr-checkbox" [ngClass]="{'checked': value, 'disabled': disabled}">
  <label [for]="rand"><ng-content></ng-content></label>
  <input type="checkbox" [(ngModel)]="value" [id]="rand" [disabled]="disabled">
</div>
